import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PersonClient } from '@models/clients';
import { ClientsDispatch } from '@state/clients';
import { EditClientModalComponent } from '../edit-modal/edit-modal.component';

@Component({
	selector: 'app-edit-person-client',
	templateUrl: './edit-person-client.component.html',
	standalone: false,
})
export class EditPersonClientComponent {
	@Input() client: PersonClient;

	public formItems = [
		{ value: 'male', label: 'Male' },
		{ value: 'female', label: 'Female' },
		{ value: 'non-binary', label: 'Non-binary' },
	];

	constructor(
		private clientsDispatch: ClientsDispatch,
		private dialogRef: MatDialogRef<EditClientModalComponent>,
	) {}

	onSubmit(form: NgForm) {
		if (form.valid) {
			this.clientsDispatch.CreateOrMerge(this.client.id, {
				firstName: this.client.firstName,
				middleNames: this.client.middleNames,
				lastName: this.client.lastName,
				email: this.client.email ?? null,
				phone: this.client.phone,
				title: this.client.title ?? null,
				representation: this.client.representation,
				gender: this.client.gender ?? null,
				dateOfBirth: this.client.dateOfBirth ?? null,
			});

			this.dialogRef.close();
		}
	}
}
